var morseCode = {
  init () {
    $('[id=morse]').on('keyup', function () {
      let container = $(this).closest('form');
      if (container.length == 0) {
        container = $('body');
      }
      var value  = $(this).val();
      var output = '';
      if (value === '') {
        container.find('#text').text('');
      }
      for (var i = 0; i < value.length; i++) {
        output += morseCode.converter[value.charAt(i).toLowerCase()];
      }
      container.find('#morse-text').text(output);
      container.find('#morse-code').val(output);
    });
  },
  
  converter: {
    'a': '.- ',
    'b': '-... ',
    'c': '-.-. ',
    'd': '-.. ',
    'e': '. ',
    'f': '..-. ',
    'g': '--. ',
    'h': '.... ',
    'i': '.. ',
    'j': '.--- ',
    'k': '-.- ',
    'l': '.-.. ',
    'm': '-- ',
    'n': '-. ',
    'o': '--- ',
    'p': '.--. ',
    'q': '--.- ',
    'r': '.-. ',
    's': '... ',
    't': '- ',
    'u': '..- ',
    'v': '...- ',
    'w': '.-- ',
    'x': '-..- ',
    'y': '-.-- ',
    'z': '--.. ',
    '1': '.---- ',
    '2': '..--- ',
    '3': '...-- ',
    '4': '....- ',
    '5': '..... ',
    '6': '-.... ',
    '7': '--... ',
    '8': '---.. ',
    '9': '----. ',
    '0': '----- ',
    '.': '.-.-.- ',
    ',': '--..-- ',
    '?': '..--.. ',
    "'": '.----. ',
    '!': '-.-.-- ',
    '/': '-..-. ',
    '(': '-.--. ',
    ')': '-.--.- ',
    '&': '.-... ',
    ':': '---... ',
    ';': '-.-.-. ',
    '=': '-...- ',
    '+': '.-.-. ',
    '-': '-....- ',
    '_': '..--.- ',
    '"': '.-..-. ',
    '$': '...-..- ',
    '@': '.--.-. ',
    ' ': '/'
  }
}

$(document).ready(function() {
	console.log("Morse script loading");
	morseCode.init()
});